import { gql } from "@apollo/client";

export const USER_POOL_GET_CARD_REGISTER_CLIENT_SECRET = gql`
  query UserPoolGetCardRegisterClientSecret($currency: CurrencyTypes) {
    results: getCardRegisterClientSecretAndCustomerId(currency: $currency) {
      clientSecret
      customerId
    }
  }
`;
